module.exports = __webpack_public_path__ + "img/edit-icon.806ed702.svg";